import { PropsWithChildren } from 'react'
import { Accordion } from '@/global/components/Accordion'
import { WButton, WParagraph, WTitle } from '@alice-health/wonderland-react'

interface FormTemplateProps {
  title: string
  accordionDescription?: string
  submitButtonLabel?: string
  loading?: boolean
  disabled?: boolean
  backButton?: boolean
  onBack?: () => void
}

const FormTemplate = ({
  title,
  accordionDescription,
  submitButtonLabel,
  backButton,
  loading,
  disabled,
  onBack,
  children
}: PropsWithChildren<FormTemplateProps>) => {
  return (
    <div className='py-gl-spacing-06 px-gl-spacing-08 h-full flex flex-col md:justify-between'>
      <div>
        <div className='pb-gl-spacing-06 flex flex-col gap-3 justify-between'>
          <WTitle
            size='small'
            variant='heavy'
            level='2'
          >
            {title}
          </WTitle>

          {accordionDescription ? (
            <Accordion
              title='Por que essa pergunta?'
              border={false}
              bleeded={true}
            >
              <WParagraph size='medium'>{accordionDescription}</WParagraph>
            </Accordion>
          ) : null}
        </div>

        {children}
      </div>

      <footer
        className={`mt-3 mb-12 md:mb-0 flex ${
          backButton ? 'justify-between' : 'justify-start md:justify-end'
        }`}
      >
        {backButton ? (
          <WButton
            variant='secondary'
            icon='icArrowLeft'
            iconButton
            onClick={onBack}
            disabled={loading}
          />
        ) : null}

        {submitButtonLabel ? (
          <WButton
            type='submit'
            variant='cta'
            icon='icArrowRight'
            iconPosition='trailing'
            loading={loading}
            disabled={disabled}
          >
            {submitButtonLabel}
          </WButton>
        ) : null}
      </footer>
    </div>
  )
}

export { FormTemplate }
export type { FormTemplateProps }
